// This file is now deprecated - use the TranslationContext instead
export { useTranslation } from '@/contexts/TranslationContext';